// Customers list tab
import * as Contacts          from '../contacts';
import * as UI                from '../ui';
import * as User              from '../user';
import { compose }            from 'redux';
import { connect }            from 'react-redux';
import { Navbar as F7Navbar } from 'framework7-react';
import AllContacts            from './all_contacts';
import FetchFromServer        from '../components/fetch_from_server';
import Navbar                 from '../components/navbar';
import React                  from 'react';
import withMainRouteParams    from '../components/with_main_route_params';


export default withMainRouteParams(
  connect(
    (state, { businessID, contactID }) => ({
      businessID,
      contactID,
      statuses:          Contacts.getContactsStatuses(state, businessID),
      contacts:          Contacts.getContacts(state, businessID),
      isLoadingContacts: UI.isLoadingContacts(state),
      currentUserID:     User.getUserID(state)
    }),
    (dispatch, { businessID }) => ({
      load: compose(dispatch, Contacts.readContactsPagination, () => ({ businessID }))
    })
  )(ContactsList)
);


function ContactsList({ businessID, contactID, contacts, isLoadingContacts, currentUserID, statuses, load }) {
  const { readStatus } = statuses;

  return (
    <div className="page" data-name="contacts">
      <F7Navbar title="Contacts">
        <Navbar.LeftButton label=""/>
        <Navbar.RightButton label="Add" href={`/${businessID}/contacts/add`}/>
      </F7Navbar>
      <FetchFromServer {...{ statuses, load }}>
        <AllContacts {...{ businessID, contactID, contacts, readStatus, isLoadingContacts, currentUserID }}/>
      </FetchFromServer>
    </div>
  );
}
